module.exports = __webpack_public_path__ + "img/card_1_ref_1.6a5541e6.jpg";